import { FC, useEffect, useState } from 'react';
import dayjs from 'dayjs';

import { RecentNewsArticleModel } from '../../../core/apiSchema';
import { useMediaQuery } from '../../../core/hooks/useMediaQuery';
import ColumnSlider from '../../../components/ColumnSlider/ColumnSlider';

import './FeaturedArticlesSlider.styles.scss';

interface iFeaturedArticlesSliderProps {
    articles: RecentNewsArticleModel[];
    navigateToArticle: (articleId?: number) => void;
}

const FeaturedArticlesSlider: FC<iFeaturedArticlesSliderProps> = ({ articles, navigateToArticle }) => {
    const [slidesPerView, setSlidesPerView] = useState<number>(0);
    const maxOneSlideWidth = useMediaQuery(600);

    useEffect(() => {
        if (maxOneSlideWidth) {
            setSlidesPerView(1);
        } else {
            setSlidesPerView(2);
        }
    }, [maxOneSlideWidth]);

    if (!articles.length) return null;

    return (
        <div className="FeaturedArticlesSlider">
            <ColumnSlider slidesPerView={slidesPerView}>
                {articles.map((article) => (
                    <div key={article.id} className="FeaturedArticlesSlider__card" onClick={() => navigateToArticle(article.id)}>
                        <img
                            className="FeaturedArticlesSlider__image"
                            src={article.featuredImage || ''}
                            alt={article.title || ''}
                        />
                        <div className="FeaturedArticlesSlider__overlay">
                            <span className="FeaturedArticlesSlider__title">{article.title}</span>
                            <div className="FeaturedArticlesSlider__date">
                                {article.publishedDate ? dayjs(article.publishedDate).format('MMMM D, YYYY') : ''}
                            </div>
                            <span className="FeaturedArticlesSlider__description">{article?.description || ''}</span>
                        </div>
                    </div>
                ))}
            </ColumnSlider>
        </div>
    );
};

export default FeaturedArticlesSlider;
